var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.72917V2.29167C0 1.66146 0.224583 1.12215 0.67375 0.67375C1.12292 0.225347 1.66222 0.000763889 2.29167 0H16.0417C16.6719 0 17.2116 0.224583 17.6607 0.67375C18.1099 1.12292 18.3341 1.66222 18.3333 2.29167V5.72917H16.6667V1.66667H1.66667V5.72917H0Z",
    fill: "#3C5873"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.07512 3.74038C8.70156 3.19747 9.63178 3.19747 10.2582 3.74038L14.2743 7.22097C15.4402 8.23142 14.7256 10.1471 13.1827 10.1471H11.6667V16.8138C11.6667 17.7343 10.9205 18.4805 10 18.4805H8.33333C7.41286 18.4805 6.66667 17.7343 6.66667 16.8138V10.1471H5.15061C3.60776 10.1471 2.89315 8.23142 4.05905 7.22097L8.07512 3.74038ZM9.71244 5.47287C9.39922 5.20141 8.93411 5.20142 8.62089 5.47287L5.15061 8.48045H7.08333C7.77369 8.48045 8.33333 9.0401 8.33333 9.73045V16.8138H10V9.73045C10 9.0401 10.5596 8.48045 11.25 8.48045H13.1827L9.71244 5.47287Z",
    fill: "#3C5873"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.a826ff84.svg";
export { ForwardRef as ReactComponent };